import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, InputAdornment, OutlinedInput, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import AnexoButton from "../../../../components/AnexoButton";
import { Anexo } from "../../../../interfaces/entities/Reembolso/Anexo";
import { ThirdStepProps } from "../../../../interfaces/props/Financeiro/Reembolso/ThirdStepProps";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { sxButton, sxInput, sxLabel, sxStartAdornment } from "./sxProps";
import { formatStringToReaisNumberFormat } from "../../../../utils/MoneyFormat";

function StepDadosProcedimentoExecutivo(props: ThirdStepProps) {
  const [cost, setCost] = useState<string>('');
  const [anexos, setAnexos] = useState<Array<Anexo>>([]);

  const accessibility = useAccessibility();

  useEffect(() => {
    if (props.userRequestedToEditInfos && props.anexosAdicionados.length > 0 && props.valorTotalApontado) {
      setCost(props.valorTotalApontado);
      setAnexos(props.anexosAdicionados);
    }
  }, [])

  const handleCostChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const digits = value.replace(/^0+/, '');
    const noDot = digits.replace(/\./g, '');
    const onlyDigits = noDot.replace(/[^\d]/g, '');
    if (onlyDigits.length === 0 || onlyDigits === '0') {
      setCost('');
    }
    else if (onlyDigits.length === 1) {
      setCost(`0.0${onlyDigits}`);
    }
    else if (onlyDigits.length === 2) {
      setCost(`0.${onlyDigits}`);
    }
    else {
      let maskedValue = '';
      const len = onlyDigits.length;
      for (let i = 0; i < len; i++) {
        maskedValue += onlyDigits[i];
        if ((len - i) === 3 && i !== len - 1) {
          maskedValue += '.';
        }
      }
      setCost(maskedValue);
    }
  }

  const goBack = () => {
    props.handleBackThirdStep();
  }

  const saveFiles = (Anexos: Array<Anexo>) => {
    setAnexos(Anexos);
  };

  const handleThirdStep = () => {
    props.handleThirdStep(anexos, cost);
  }

  const formattedCost = formatStringToReaisNumberFormat(cost);

  return (
    <div className="refund-request-second-step-content">
      <h1 className="first-step-title" style={accessibility.textStyleAccessibility}>Dados da despesa</h1>
      <div className="first-step-contact">
        <div className="first-step-contact-info">
          <Typography sx={sxLabel} style={accessibility.textStyleAccessibility}>Valor total do gasto</Typography>
          <OutlinedInput
            fullWidth
            type={'text'}
            value={!!cost ? formattedCost : ''}
            onChange={handleCostChange}
            name='cost'
            maxRows={1}
            inputProps={{ maxLength: 15 }}
            placeholder="Digite o valor pago"
            startAdornment={cost === '' ? null : <InputAdornment sx={sxStartAdornment} position="start"><span style={{ ...(accessibility.contrastMode ? accessibility.textStyleAccessibility : {}), fontSize: '16px' }}>R$</span></InputAdornment>}
            sx={sxInput}
            style={accessibility.textStyleAccessibility}
          />
        </div>
        <span className="third-step-file" style={accessibility.textStyleAccessibility}>Anexe exames ou documentos na solicitação:</span>
        <div className="third-step-buttons">
          <div className="third-step-file-button">
            <AnexoButton salvarAnexos={saveFiles} anexos={anexos} />
          </div>
          <div className="third-step-file-guide">
            <span style={accessibility.textStyleAccessibility} className="third-step-file">
              Você pode anexar arquivos .pdf, .jpg, .doc e .png de até 4mb, sendo de notas fiscais/recibos, pedidos médicos, relatórios médicos, entre outros.
            </span>
          </div>
          <div className="first-step-contact-button">
            <Button
              variant="contained"
              type='submit'
              sx={sxButton}
              disabled={cost === '' || anexos.length === 0}
              onClick={handleThirdStep}
              style={accessibility.buttonStyleAccessibility}
              fullWidth>
              <span style={accessibility.buttonTextStyleAccessibility}>
                Continuar
              </span>
            </Button>
          </div>
          <button style={accessibility.textStyleAccessibility} className="back-button margin-top-30" onClick={goBack}>
            <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
          </button>
        </div>
      </div>
    </div>
  )
}

export default StepDadosProcedimentoExecutivo;